import { render, staticRenderFns } from "./TemplateSignerDialogComponent.vue?vue&type=template&id=07b14936&scoped=true&"
import script from "./TemplateSignerDialogComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateSignerDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSignerDialogComponent.vue?vue&type=style&index=0&id=07b14936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b14936",
  null
  
)

export default component.exports